// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__26-Q-","checkboxCol":"Table_checkboxCol__1Qn1K","emailCol":"Table_emailCol__2dB3-","actionCol":"Table_actionCol__1DrMP"};